/**
 * activateUser.js
 * Written by: Li Liu
 */

import event, { trackFacebookConversion } from '../../../../utils/event';
import request from '../../../request/actions';
import alertActions from '../../../alert/actions';

export const ACTIVATE_USER_START = `ACTIVATE_USER_START`;
export const ACTIVATE_USER_SUCCESS = `ACTIVATE_USER_SUCCESS`;
export const ACTIVATE_USER_FAILURE = `ACTIVATE_USER_FAILURE`;

export const activateUserStart = () => ({
  type: ACTIVATE_USER_START,
});

export const activateUserSuccess = () => ({
  type: ACTIVATE_USER_SUCCESS,
});

export const activateUserFailure = (error) => ({
  type: ACTIVATE_USER_FAILURE,
  error,
});

export const activateUser = (id, token) => async (dispatch) => {
  dispatch(activateUserStart());
  let response;
  try {
    const data = { token };
    response = await dispatch(request(`/users/${id}/activate/`, `POST`, data));
    dispatch(activateUserSuccess());
    dispatch(
      alertActions.createAlert({
        message: `Your email has been confirmed!`,
        type: `success`,
        time: 5000,
      }),
    );
    event(`confirm-email`, [`alert`, `confirm-email`, `${id}`]);
    trackFacebookConversion(`CompleteConfirmation`, `{'user_id': '${id}'}`);
    return response;
  } catch (error) {
    dispatch(activateUserFailure(error.response ? error.response : error.message));
    event(`confirm-email-failure`, [`alert`, `confirm-email-failure`, `${error.response ? error.response.data.detail : error.message}`, id]);
    dispatch(
      alertActions.createAlert({
        message: `Confirmation Error: ${error.response ? error.response.data.detail : `An unknown error occured`}`,
        type: `error`,
        time: 5000,
      }),
    );
    return error.response;
  }
};
